import React, { Component } from 'react';
import { CollapsibleCard } from '../../shared/CollapsibleCard';
import { CustomKendoGrid } from '../../shared/CustomKendoGrid';
import { GridColumn, GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { PayrollDataService } from '../../services/PayrollDataService';
import { ViewReportButton } from '../../shared/ViewReportButton';

export class PayrollHistory extends Component {
    constructor(props) {
        super(props);
        this.payrollDataService = new PayrollDataService();
        this.getPayrollHistory = this.getPayrollHistory.bind(this);
        this.handlePrint = this.handlePrint.bind(this);

        this.gridRef = null;
        this.setGridRef = element => {
            this.gridRef = element;
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps) return null;
        if (!this.props) return null;
        if (!this.gridRef) return null;
        if (prevProps.district !== this.props.district) {
            this.gridRef.handleDataCallback();
        }
        return null;
    }

    getPayrollHistory() {
        return this.payrollDataService.getPayrollInfo(this.props.district).then((data) => {
            return data.map(
              (item) => {
                    return Object.assign(item, {
                        datePaidDisplay: new Date(item.datePaid),
                      periodEnd: new Date(item.periodEnd)
                    });
                });
        });
    }

    handlePrint(obj) {
        return this.payrollDataService.getPaystub(this.props.district, obj.datePaid)
            .then(data => data.json());
    }

    render() {
        return (
            <CollapsibleCard title='Payroll History'>
                <CustomKendoGrid
                    ref={this.setGridRef}
                    refreshData={this.getPayrollHistory}>
                    <GridColumn cell={(props) => (
                        <td>
                            <ViewReportButton defaultFilename='apd.pdf' getData={() => this.handlePrint(props.dataItem)}></ViewReportButton>
                        </td>
                    )} />
                    <GridColumn title="Date Paid" field="datePaidDisplay" format="{0:MM/dd/yyyy}" filter="date" columnMenu={GridColumnMenuFilter} />
                    <GridColumn title="Period End" field="periodEnd" format="{0:MM/dd/yyyy}" filter="date" columnMenu={GridColumnMenuFilter} />
                    <GridColumn title="Document No" field="documentNumber" filter="numeric" columnMenu={GridColumnMenuFilter} />
                    <GridColumn title="Document Type" field="documentType" columnMenu={GridColumnMenuFilter} />
                    <GridColumn title="Net Pay" field="netPay" format="{0:c}" filter="numeric" columnMenu={GridColumnMenuFilter} />
                </CustomKendoGrid>
            </CollapsibleCard>
        );
    }
}
